import { render, staticRenderFns } from "./ActiveContacts.vue?vue&type=template&id=fcce776a&scoped=true"
import script from "./ActiveContacts.vue?vue&type=script&lang=js"
export * from "./ActiveContacts.vue?vue&type=script&lang=js"
import style0 from "./ActiveContacts.vue?vue&type=style&index=0&id=fcce776a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcce776a",
  null
  
)

export default component.exports